<template>
  <DragDialog
    title="设置单位"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
  >
    <div class="unit-box">
      <div class="dialog-label">单位：</div>
      <div class="common-select-box">
        <el-select
          size="small"
          v-model="unit"
          placeholder="请选择单位"
          class="primary-select"
          popper-class="primary-select-outer"
        >
          <el-option
            v-for="(item, index) in unitList"
            :key="index"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

export default {
  data() {
    return {
      unit: "",
      unitList: [
        { name: "毫米", value: "Millimeter" },
        { name: "厘米", value: "Centimeter" },
        { name: "米", value: "Meter" },
        { name: "千米", value: "Kilometer" },
        { name: "英寸", value: "Inch" },
        { name: "英尺", value: "Foot" },
        { name: "英里", value: "Mile" },
      ],
    };
  },
  props: {
    visible: Boolean,
    initUnit: String,
    submitUnit: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    initUnit: function (newValue) {
      if (newValue) {
        this.unit = newValue;
      }
    },
  },
  methods: {
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false;
        clearInterval(startInterval);
      }, 60000);

      if (!this.disabled) {
        let paramsInfo = { unit: this.unit };
        this.submitUnit(paramsInfo).then((response) => {
          if (response.isSuccess) {
            this.disabled = false;
            this.unit = "";
            this.closeDialog();
          } else {
            this.disabled = false;
            this.$message.error(response.errMsg);
            return;
          }
        });
      }
    },
    cancel() {
      this.unit = "";
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.unit-box {
  display: flex;
  line-height: 32px;
  color: var(--default-color);

  .dialog-label{
    white-space: nowrap;
  }

  .common-select-box {
    text-align: left;
    width: 100%;
    .primary-select{
      width: 100%;
    }
  }
}
</style>